import { Divider, Typography } from '@forgeglobal/design-framework';
import { FORGETRUST } from '@tcs/common/assets/constants';
import { useStyles } from './style';

const MainDisclaimer = () => {
  const classes = useStyles();
  const { MAIN_DISCLAIMER } = FORGETRUST;

  return (
    <div className={classes.wrapper}>
      <Typography
        variant="caption"
        data-test-id="main-disclaimer"
        className={classes.disclaimer}>
        <Divider className={classes.divider} />
        {MAIN_DISCLAIMER}
      </Typography>
    </div>
  );
};
export default MainDisclaimer;
